import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly baseUrl = environment.apiUrl;
  private http = inject(HttpClient);

  get<T>(
    endpoint: string,
    queryParams?: Record<string, string>
  ): Observable<T> {
    let url = `${this.baseUrl}/${endpoint}`;

    if (queryParams && Object.keys(queryParams).length > 0) {
      const params = Object.entries(queryParams)
        .filter(([, value]) => value !== undefined && value !== null)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

      if (params) {
        url += `?${params}`;
        console.log('API GET Request URL:', url); // Log the final URL for debugging
      }
    }

    return this.http.get<T>(url).pipe(catchError(this.handleError));
  }

  post<T, U>(endpoint: string, body: U) {
    return this.http
      .post<T>(`${this.baseUrl}/${endpoint}`, body)
      .pipe(catchError(this.handleError));
  }

  postCsv<T, U>(endpoint: string, body: U, responseType: 'text' = 'text') {
    return this.http
      .post<T>(`${this.baseUrl}/${endpoint}`, body, { responseType } as any)
      .pipe(catchError(this.handleError));
  }

  put<T, U>(endpoint: string, body: U) {
    return this.http
      .put<T>(`${this.baseUrl}/${endpoint}`, body)
      .pipe(catchError(this.handleError));
  }

  patch<T>(endpoint: string, body: any, options?: any) {
    return this.http
      .patch<T>(`${this.baseUrl}/${endpoint}`, body, options)
      .pipe(catchError(this.handleError));
  }

  delete<T>(endpoint: string, options?: any) {
    return this.http
      .delete<T>(`${this.baseUrl}/${endpoint}`, options)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      console.error('An error occurred:', error.error);
    } else {
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    return throwError(
      () => new Error('Something bad happened; please try again later.')
    );
  }
}
